import { useContext, useEffect, useRef, useState } from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import axios from "axios";
import { Button } from "@mui/material";
import html2canvas from "html2canvas";
import { GlobalContext } from "../Context/GlobalContext";

const useImageWithLocation = () => {
  const { imageRenderDataState } = useContext(GlobalContext);
  const [imageRenderData, setImageRenderData] = imageRenderDataState;

  const handleLocation = async (lat, long) => {
    try {
      let { data: response } = await axios.get(
        `https://api.common-wrapper.embifi.in/v1/map/geocode?lat=${lat}&long=${long}`
      );
      return response?.data?.results?.[0]?.formatted_address;
    } catch (error) {
      return "Location not found";
    }
  };

  //   const handleDownload = () => {
  //     html2canvas(divRef.current, {
  //       allowTaint: true,
  //       useCORS: true,
  //       onclone: (clonedDoc) => {
  //         clonedDoc.getElementById("image-with-location").style.display = "block";
  //       },
  //     }).then((canvas) => {
  //       const imgData = canvas.toDataURL();
  //       console.log(imgData);
  //     });
  //   };

  //   useEffect(() => {
  //     handleDownload();
  //   }, [locationAddress]);

  //   const handleDownload = () => {
  //     domtoimage
  //       .toPng(document.getElementById("image-with-location"), {quality: 1})
  //       .then(function (data) {
  //         console.log(data);
  //       })
  //       .catch(function (error) {
  //         console.error("oops, something went wrong!", error);
  //       });
  //   };

  const getImageWithLocation = async (loc, file, name="") => {
    try {
      let address = await handleLocation(loc?.lat, loc.long);
      // let address = await handleLocation(18.555380, 73.810577);
      setImageRenderData({
        ...imageRenderData,
        location: loc,
        image: file,
        address,
      });
      // console.log(address);
      return new Promise((resolve) => {
        setTimeout(() => {
          (async () => {
            let canvas = await html2canvas(
              document.getElementById("image-with-location"),
              {
                allowTaint: true,
                useCORS: true,
                onclone: (clonedDoc) => {
                  clonedDoc.getElementById(
                    "image-with-location"
                  ).style.display = "block";
                },
              }
            );
            const imgData = await canvas.toDataURL();
            resolve(imgData);
          })();
        }, 500);
      });
    } catch (err) {
      console.log(err);
      return "";
    }
  };

  return {
    getImageWithLocation,
  };
};

export const RenderCanvas = ({ dimension }) => {
  const { imageRenderDataState } = useContext(GlobalContext);
  const [imageRenderData, setImageRenderData] = imageRenderDataState;
  return (
    <>
      <div
        id="image-with-location"
        style={{ position: "relative", display: "none" }}
      >
        <img src={imageRenderData?.image} width={"100%"} />
        <div className="location-holder">
          <div className="location-div py-2">
            <p
              style={
                dimension ? { fontSize: dimension?.fontSize } : { fontSize: 20 }
              }
            >
              <span>
                {" "}
                <LocationOnIcon
                  sx={
                    dimension
                      ? { fontSize: dimension?.fontSize }
                      : { fontSize: 20 }
                  }
                />{" "}
                Coordinates:
              </span>{" "}
              {imageRenderData?.location?.lat},{" "}
              {imageRenderData?.location?.long}
            </p>
            <p style={dimension ? dimension : { maxWidth: 300, fontSize: 20 }}>
              <span>Address:</span> : {imageRenderData?.address}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default useImageWithLocation;
